module.exports = __webpack_public_path__ + "img/Johannes.65f4c56b.jpeg";